export const categories = [
  {
    slug: "getting-started",
    name: "入门指南",
    description: "新用户快速上手 91n.com 的基础教程与注册指引",
    icon: "ri-rocket-line",
    articleCount: 12,
  },
  {
    slug: "feature-tutorials",
    name: "功能教程",
    description: "深入讲解 91n.com 各项核心功能的详细操作指南",
    icon: "ri-book-open-line",
    articleCount: 18,
  },
  {
    slug: "faq",
    name: "常见问题",
    description: "汇总用户在使用 91n.com 过程中遇到的常见疑问与解答",
    icon: "ri-question-answer-line",
    articleCount: 25,
  },
  {
    slug: "latest-news",
    name: "最新动态",
    description: "91n.com 平台更新公告、活动资讯与行业动态",
    icon: "ri-flashlight-line",
    articleCount: 8,
  },
  {
    slug: "security-tips",
    name: "安全须知",
    description: "保障账号安全、防范风险的实用建议与官方提醒",
    icon: "ri-shield-check-line",
    articleCount: 10,
  },
];

export const articles = [
  {
    id: "art-001",
    slug: "how-to-access-91n",
    title: "如何正确访问 91n.com 官方入口",
    excerpt: "详细讲解通过浏览器、移动端等多种方式安全访问 91n.com 官方入口的完整步骤，确保您始终连接到正确的官方地址。",
    content: `<p>在互联网时代，找到正确的官方入口至关重要。本文将详细介绍如何安全、便捷地访问 91n.com 官方入口。</p>
<h2>一、通过浏览器直接访问</h2>
<p>最简单的访问方式是在浏览器地址栏中直接输入 91n.com 官方地址。请确保您输入的是正确的官方域名，避免访问到仿冒网站。</p>
<p>建议将正确的 91n.com 地址添加到浏览器书签中，这样可以避免每次手动输入的麻烦，也能防止输入错误的网址。</p>
<h2>二、通过搜索引擎查找</h2>
<p>您也可以在主流搜索引擎中搜索「91n.com 官方入口」或「91n.com 官网」来找到正确的访问地址。请注意甄别搜索结果，选择标注为「官方」的链接。</p>
<h2>三、移动端访问方法</h2>
<p>在手机或平板等移动设备上，同样可以通过浏览器访问 91n.com。移动端页面会自动适配屏幕尺寸，提供良好的浏览体验。</p>
<h2>四、注意事项</h2>
<p>请勿通过不明来源的链接访问 91n.com，避免点击来路不明的广告或弹窗。始终通过本页面提供的官方入口进行访问，确保您的信息安全。</p>`,
    category: "getting-started",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20web%20browser%20window%20displaying%20a%20clean%20website%20interface%20with%20soft%20warm%20ambient%20lighting%2C%20digital%20navigation%20concept%2C%20clean%20composition%2C%20editorial%20style%20photography%20with%20simple%20background&width=800&height=450&seq=art-001-cover&orientation=landscape",
    author: "91n指南编辑部",
    publishDate: "2026-08-01",
    readTime: "5分钟",
    tags: ["访问入口", "官方地址", "使用教程"],
    featured: true,
  },
  {
    id: "art-002",
    slug: "91n-registration-guide",
    title: "91n.com 新用户注册完整流程指南",
    excerpt: "从零开始，手把手教您完成 91n.com 的账号注册、信息填写及初始设置，让您快速开启使用之旅。",
    content: `<p>欢迎加入 91n.com！本文将引导您完成从注册到初始设置的全部流程。</p>
<h2>一、注册前准备</h2>
<p>在开始注册之前，请准备好一个有效的电子邮箱地址和手机号码。这两个信息将用于账号验证和安全保护。</p>
<h2>二、填写注册信息</h2>
<p>进入 91n.com 注册页面后，按照提示填写用户名、密码、邮箱和手机号等基本信息。请使用真实有效的信息，以便后续找回账号。</p>
<h2>三、邮箱与手机验证</h2>
<p>提交注册信息后，系统会向您的邮箱发送验证链接，同时向手机发送验证码。请按照提示完成双重验证，确保账号安全。</p>
<h2>四、初始设置建议</h2>
<p>注册成功后，建议立即完善个人资料、设置安全问题和绑定备用联系方式。这些措施能有效保护您的账号安全。</p>`,
    category: "getting-started",
    coverImage: "https://readdy.ai/api/search-image?query=Clean%20modern%20registration%20form%20on%20a%20laptop%20screen%20with%20warm%20ambient%20light%2C%20minimalist%20UI%20design%2C%20soft%20shadows%2C%20editorial%20product%20photography%20with%20simple%20neutral%20background&width=800&height=450&seq=art-002-cover&orientation=landscape",
    author: "91n指南编辑部",
    publishDate: "2026-07-28",
    readTime: "6分钟",
    tags: ["注册教程", "新手指南", "账号设置"],
    featured: true,
  },
  {
    id: "art-003",
    slug: "91n-core-features-overview",
    title: "91n.com 核心功能全景解析",
    excerpt: "全面梳理 91n.com 平台的核心功能模块，帮助您快速了解平台能做什么、怎么用，充分发挥平台价值。",
    content: `<p>91n.com 提供了丰富多样的功能，本文将为您做一个全面的梳理和介绍。</p>
<h2>一、信息浏览功能</h2>
<p>91n.com 的核心功能之一是信息浏览。您可以在平台上浏览各类分类整理的内容，通过标签和搜索快速定位所需信息。</p>
<h2>二、互动交流功能</h2>
<p>平台支持用户之间的互动交流，包括评论、点赞、分享等功能，让信息获取不再是单向的。</p>
<h2>三、个性化设置</h2>
<p>您可以根据自己的偏好进行个性化设置，包括界面主题、内容偏好、通知方式等，打造专属的使用体验。</p>
<h2>四、数据管理功能</h2>
<p>平台提供完善的数据管理功能，您可以方便地查看和管理自己的使用记录、收藏内容和历史数据。</p>`,
    category: "feature-tutorials",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20digital%20dashboard%20with%20multiple%20feature%20panels%20displayed%20on%20a%20clean%20interface%2C%20warm%20ambient%20lighting%2C%20minimalist%20design%2C%20editorial%20style%20product%20photography%20with%20neutral%20background&width=800&height=450&seq=art-003-cover&orientation=landscape",
    author: "91n指南编辑部",
    publishDate: "2026-07-25",
    readTime: "8分钟",
    tags: ["功能介绍", "平台概览", "核心功能"],
    featured: true,
  },
  {
    id: "art-004",
    slug: "91n-security-best-practices",
    title: "91n.com 账号安全防护最佳实践",
    excerpt: "汇总官方推荐的安全设置方案，帮助您有效保护 91n.com 账号免受盗用和欺诈风险。",
    content: `<p>账号安全是每位用户都应重视的问题。本文将分享 91n.com 账号安全防护的最佳实践。</p>
<h2>一、设置强密码</h2>
<p>使用包含大小写字母、数字和特殊字符的复杂密码，长度不少于12位。避免使用生日、手机号等容易被猜测的信息作为密码。</p>
<h2>二、开启双重验证</h2>
<p>强烈建议开启双重验证功能。即使密码不慎泄露，攻击者也无法轻易登录您的账号。</p>
<h2>三、定期检查登录记录</h2>
<p>定期查看账号的登录历史记录，如发现异常登录行为，请立即修改密码并联系官方客服。</p>
<h2>四、警惕钓鱼攻击</h2>
<p>切勿点击来路不明的链接，尤其是那些声称来自 91n.com 官方但域名可疑的链接。始终通过本页提供的官方入口访问。</p>`,
    category: "security-tips",
    coverImage: "https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20shield%20icon%20and%20lock%20symbols%20on%20a%20clean%20dark%20interface%2C%20warm%20ambient%20lighting%2C%20minimalist%20design%2C%20professional%20editorial%20photography%20with%20simple%20background&width=800&height=450&seq=art-004-cover&orientation=landscape",
    author: "91n安全团队",
    publishDate: "2026-07-20",
    readTime: "7分钟",
    tags: ["账号安全", "安全防护", "最佳实践"],
    featured: false,
  },
  {
    id: "art-005",
    slug: "91n-mobile-app-guide",
    title: "91n.com 移动端使用完全指南",
    excerpt: "详细介绍 91n.com 在手机和平板等移动设备上的访问和使用方法，让您随时随地畅享服务。",
    content: `<p>移动互联网时代，随时随地访问 91n.com 是很多用户的需求。本文将详细介绍移动端的使用方法。</p>
<h2>一、移动浏览器访问</h2>
<p>使用手机自带浏览器或 Chrome、Safari 等主流浏览器，直接访问 91n.com 即可。移动端页面已做优化适配，操作流畅便捷。</p>
<h2>二、添加到主屏幕</h2>
<p>您可以将 91n.com 添加到手机主屏幕，像使用原生 App 一样快速启动。在浏览器菜单中选择「添加到主屏幕」即可完成。</p>
<h2>三、移动端特色功能</h2>
<p>移动端针对触屏操作进行了优化，支持手势操作、快速滑动浏览等功能，提供与桌面端同样完善的使用体验。</p>`,
    category: "feature-tutorials",
    coverImage: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20clean%20modern%20mobile%20website%20interface%20on%20a%20minimalist%20desk%20setup%2C%20warm%20natural%20lighting%2C%20editorial%20product%20photography%20with%20simple%20neutral%20background&width=800&height=450&seq=art-005-cover&orientation=landscape",
    author: "91n指南编辑部",
    publishDate: "2026-07-18",
    readTime: "5分钟",
    tags: ["移动端", "手机访问", "使用教程"],
    featured: false,
  },
  {
    id: "art-006",
    slug: "91n-faq-collection",
    title: "91n.com 常见问题汇总解答（2026最新版）",
    excerpt: "整理 2026 年用户最常问的 20+ 个问题，涵盖访问、注册、功能、安全等方方面面，一站式答疑。",
    content: `<p>本文汇总了 91n.com 用户最常咨询的问题，并提供官方解答。建议收藏本页以备不时之需。</p>
<h2>访问相关</h2>
<p><strong>Q：91n.com 打不开了怎么办？</strong></p>
<p>A：请先检查网络连接，确认输入的地址是否正确。如仍无法访问，可尝试清除浏览器缓存或更换浏览器。</p>
<p><strong>Q：如何确认访问的是正确的 91n.com 官网？</strong></p>
<p>A：请认准本页面提供的官方入口地址，并注意浏览器地址栏的安全锁标识。</p>
<h2>账号相关</h2>
<p><strong>Q：忘记密码如何找回？</strong></p>
<p>A：在登录页面点击「忘记密码」，按照提示通过绑定的邮箱或手机号重置密码。</p>
<p><strong>Q：可以注销账号吗？</strong></p>
<p>A：可以。请在设置页面找到账号管理选项，按照流程申请注销。</p>`,
    category: "faq",
    coverImage: "https://readdy.ai/api/search-image?query=Clean%20modern%20FAQ%20help%20center%20interface%20with%20question%20marks%20and%20information%20icons%2C%20warm%20ambient%20lighting%2C%20minimalist%20design%2C%20editorial%20photography%20with%20simple%20neutral%20background&width=800&height=450&seq=art-006-cover&orientation=landscape",
    author: "91n客服团队",
    publishDate: "2026-08-02",
    readTime: "10分钟",
    tags: ["常见问题", "FAQ", "问题解答"],
    featured: true,
  },
  {
    id: "art-007",
    slug: "91n-latest-update-2026",
    title: "91n.com 2026年第三季度平台更新公告",
    excerpt: "了解 91n.com 最新发布的平台更新内容，包括新增功能、性能优化和界面改进。",
    content: `<p>感谢广大用户对 91n.com 的支持。现将 2026 年第三季度平台更新内容公告如下。</p>
<h2>一、新增功能</h2>
<p>本季度新增了多项用户期待已久的功能，包括智能推荐算法升级、夜间模式支持、以及更便捷的分享功能。</p>
<h2>二、性能优化</h2>
<p>我们对平台底层架构进行了全面优化，页面加载速度提升40%，响应时间缩短50%，带来更流畅的使用体验。</p>
<h2>三、界面改进</h2>
<p>UI 设计团队对整体界面进行了精细化调整，优化了导航结构，让功能更易发现、操作更直观。</p>`,
    category: "latest-news",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20update%20announcement%20concept%20with%20digital%20notification%20icons%20and%20clean%20interface%20elements%2C%20warm%20ambient%20lighting%2C%20minimalist%20design%2C%20editorial%20photography%20with%20simple%20background&width=800&height=450&seq=art-007-cover&orientation=landscape",
    author: "91n官方公告",
    publishDate: "2026-08-03",
    readTime: "4分钟",
    tags: ["更新公告", "平台动态", "新功能"],
    featured: true,
  },
  {
    id: "art-008",
    slug: "91n-beginner-quick-start",
    title: "91n.com 新手5分钟快速上手教程",
    excerpt: "专为新用户设计的极简入门指南，只需5分钟即可掌握 91n.com 的基本使用方法。",
    content: `<p>如果您是第一次使用 91n.com，这篇快速上手教程将帮助您在 5 分钟内掌握基本操作。</p>
<h2>第一步：访问并注册</h2>
<p>通过 91n.com 官方入口进入网站，点击注册按钮创建您的账号。填写基本信息并完成验证即可。</p>
<h2>第二步：熟悉界面布局</h2>
<p>登录后，花一分钟浏览主要导航栏和功能区域，了解各个模块的位置和作用。</p>
<h2>第三步：尝试核心功能</h2>
<p>从浏览内容开始，尝试搜索感兴趣的话题，收藏有用的信息，逐步探索更多功能。</p>`,
    category: "getting-started",
    coverImage: "https://readdy.ai/api/search-image?query=Clean%20beginner%20guide%20concept%20with%20step%20by%20step%20icons%20on%20a%20modern%20interface%2C%20warm%20ambient%20lighting%2C%20minimalist%20design%2C%20editorial%20photography%20with%20simple%20neutral%20background&width=800&height=450&seq=art-008-cover&orientation=landscape",
    author: "91n指南编辑部",
    publishDate: "2026-07-15",
    readTime: "3分钟",
    tags: ["快速上手", "新手教程", "入门"],
    featured: false,
  },
];

export const faqItems = [
  {
    id: "faq-001",
    question: "91n.com 的正确官方地址是什么？",
    answer: "91n.com 的官方地址即为 91n.com。建议将本页面加入收藏夹，以便随时获取最新的官方入口信息和访问指引。请勿通过不明来源的链接访问，确保您始终连接到正确的官方平台。",
  },
  {
    id: "faq-002",
    question: "访问 91n.com 需要什么条件？",
    answer: "访问 91n.com 只需一台能连接互联网的设备（电脑、手机或平板）和一款主流浏览器即可。无需安装任何额外软件，直接在浏览器中输入官方地址即可访问。建议使用 Chrome、Safari、Edge 等最新版本浏览器以获得最佳体验。",
  },
  {
    id: "faq-003",
    question: "91n.com 是否需要付费使用？",
    answer: "91n.com 基础功能完全免费。部分高级功能可能需要订阅或付费，具体以平台内实际说明为准。新用户注册后即可免费体验核心功能。",
  },
  {
    id: "faq-004",
    question: "如何确保我的 91n.com 账号安全？",
    answer: "建议采取以下措施保障账号安全：1. 设置包含大小写字母、数字和符号的强密码；2. 开启双重验证功能；3. 定期修改密码；4. 不在公共设备上保存登录状态；5. 警惕钓鱼网站，始终通过官方入口访问。",
  },
  {
    id: "faq-005",
    question: "91n.com 打不开或加载缓慢怎么办？",
    answer: "如遇到访问问题，建议依次尝试：1. 检查网络连接是否正常；2. 清除浏览器缓存和Cookie；3. 尝试使用其他浏览器；4. 检查是否使用了正确的官方地址；5. 如问题持续，可联系官方客服获取帮助。",
  },
  {
    id: "faq-006",
    question: "91n.com 支持哪些设备和平台？",
    answer: "91n.com 支持所有主流平台和设备，包括 Windows、macOS、Linux 桌面系统，以及 iOS 和 Android 移动设备。平台采用响应式设计，在不同屏幕尺寸下均能提供良好的使用体验。",
  },
  {
    id: "faq-007",
    question: "忘记 91n.com 账号密码如何找回？",
    answer: "在登录页面点击忘记密码链接，按提示输入注册时使用的邮箱或手机号，系统将发送密码重置链接或验证码。按照指引完成验证后即可设置新密码。如遇困难，可联系客服协助处理。",
  },
  {
    id: "faq-008",
    question: "91n.com 的隐私政策是怎样的？",
    answer: "91n.com 重视用户隐私保护，严格遵守相关法律法规。平台会明确告知收集哪些信息及用途，用户有权查看、修改和删除自己的个人数据。详细隐私政策请参阅平台内的隐私条款页面。",
  },
];

export const features = [
  {
    title: "官方入口直达",
    description: "提供 91n.com 最新官方访问入口，确保您始终通过正确、安全的地址访问平台，避免进入仿冒网站。",
    icon: "ri-link",
  },
  {
    title: "全面使用指南",
    description: "涵盖注册、登录、功能使用、安全设置等全方位教程，从入门到精通，满足不同用户的需求。",
    icon: "ri-guide-line",
  },
  {
    title: "实时动态更新",
    description: "第一时间同步 91n.com 平台更新公告、功能变动和重要通知，让您不会错过任何关键信息。",
    icon: "ri-notification-3-line",
  },
  {
    title: "安全防护提醒",
    description: "定期发布安全使用建议和风险防范提醒，帮助用户规避钓鱼、欺诈等网络安全威胁。",
    icon: "ri-shield-star-line",
  },
  {
    title: "常见问题解答",
    description: "整理用户高频咨询问题，提供清晰、准确的官方解答，快速解决您在使用中遇到的困惑。",
    icon: "ri-questionnaire-line",
  },
  {
    title: "多端适配支持",
    description: "无论是电脑、手机还是平板，都能获得流畅的访问体验，随时随地使用 91n.com 的各项服务。",
    icon: "ri-device-line",
  },
];